import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { getBlogPostsByCategory } from '../services/blog-posts-service'

// Custom hook để fetch blog posts theo category
export const useBlogPostsByCategory = (params: IBlogPostsServiceParams) => {
  return useQuery({
    queryKey: ['BLOGS_POST', params.categoryId, params.pageSize, params.currentPage],
    queryFn: () => getBlogPostsByCategory(params),
    staleTime: 5 * 60 * 1000, // 5 phút
    gcTime: 10 * 60 * 1000, // 10 phút
  })
}

export const useInfiniteBlogPosts = (params: {categoryId: number, pageSize: number, sortBy?: string, action?: "get_post_list" | "get_post_by_categoryId"}) => {
  const pageSize = params?.pageSize || 6
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useInfiniteQuery({
    queryKey: ['BLOGS_POST_NEW', params.categoryId],

    queryFn: ({ pageParam = 1 }) => {
      return getBlogPostsByCategory({
        pageSize: pageSize,
        currentPage: pageParam,
        categoryId: params.categoryId,
        action: params.action || 'get_post_list',
        sortBy: params.sortBy || 'Latest',
      }).then((res) => res?.data)
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      if (pages.length < (lastPage?.total_count || 0) / (lastPage?.pageInfo?.pageSize || 0)) {
        return pages.length + 1
      }
      return undefined
    },
  })
  const listBlogs = data?.pages.flatMap((page) => page?.items) ?? []
  return {
    listBlogs,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading
  }
}